import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Tooltip, CircularProgress } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import FirebaseContext from '../../../../../../../context/FirebaseContext';
import { getUserEngagementScores, getBASColor, getFeedbackFormUrl } from './utils';
import {
  BASSectionContainer,
  BASChip,
  LoadingBASChip,
  StyledFeedbackButton,
  StyledChipLabel,
} from './styles';
import texts from './texts.json';

const BASSection = ({
  clientId,
  name,
  loggedInUserDoc,
}) => {
  const {
    firebase: {
      remote,
    },
  } = useContext(FirebaseContext);

  const [clientEngagementScores, setClientEngagementScores] = useState({});
  const [isBASLoading, setIsBASLoading] = useState(true);

  useEffect(() => {
    const fetchBAS = async () => {
      if (clientId) {
        setIsBASLoading(true);
        try {
          const clientStats = await getUserEngagementScores(remote, clientId);
          setClientEngagementScores(clientStats);
        } finally {
          setIsBASLoading(false);
        }
      }
    };
    fetchBAS();
  }, [remote, clientId]);

  const handleFeedbackClick = () => {
    const formUrl = getFeedbackFormUrl(
      name,
      clientId,
      loggedInUserDoc.name,
      clientEngagementScores.basic_aggregate_score.toFixed(2),
    );
    window.open(formUrl, '_blank');
  };

  return (
    <BASSectionContainer>
      {isBASLoading ? (
        <LoadingBASChip label={<CircularProgress size={16} />} />
      ) : (
        <>
          <Tooltip title={texts.BASTooltip}>
            <BASChip
              label={(
                <StyledChipLabel>
                  {!clientEngagementScores.basic_aggregate_score
                    ? '-'
                    : `${(clientEngagementScores.basic_aggregate_score * 100).toFixed(0)}`}
                  {!!clientEngagementScores.net_momentum_score && (
                    clientEngagementScores.net_momentum_score > 0 ? (
                      <ArrowDropUpIcon sx={{ fontSize: 30 }} />
                    ) : (
                      <ArrowDropDownIcon sx={{ fontSize: 30 }} />
                    )
                  )}
                </StyledChipLabel>
              )}
              backgroundcolor={getBASColor(clientEngagementScores.basic_aggregate_score)}
              $hasScore={!!clientEngagementScores.basic_aggregate_score}
            />
          </Tooltip>
          <StyledFeedbackButton onClick={handleFeedbackClick}>
            <Tooltip title={texts.feedbackTooltip}>
              <FlagIcon fontSize="small" />
            </Tooltip>
          </StyledFeedbackButton>
        </>
      )}
    </BASSectionContainer>
  );
};

BASSection.propTypes = {
  clientId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  loggedInUserDoc: PropTypes.object.isRequired,
};

export default BASSection;
